<template>
  <v-dialog
    v-model="dialog"
    :max-width="400"
    persistent
    transition="dialog-bottom-transition"
    @click:outside="close"
  >
    <v-card class="notification-dialog">
      <v-card-text class="pa-4">
        <div class="d-flex align-center">
          <!-- 图标 -->
          <!-- <div class="notification-icon mr-4">
            <v-icon
              :icon="getIcon"
              :color="getIconColor"
              size="32"
            />
          </div> -->
          
          <!-- 内容 -->
          <div class="notification-content flex-grow-1">
            <div class="notification-title mb-2">
              {{ title }}
            </div>
            <div class="notification-message">
              {{ message }}
            </div>
          </div>
          
          <!-- 关闭按钮 -->
          <!-- <v-btn
            icon="mdi-close"
            variant="text"
            size="small"
            @click="close"
            class="notification-close-btn"
          /> -->
        </div>
      </v-card-text>
      
      <!-- 操作按钮 -->
       
      <!-- :color="getButtonColor" -->
      <v-card-actions class="pa-4 pt-0">
        <v-spacer />
        <v-btn
          color="primary"
          size="small"
          variant="flat"
          @click="close"
          class="notification-btn"
        >
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'NotificationDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    type: {
      type: String as () => 'success' | 'error' | 'warning' | 'info',
      default: 'success'
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const dialog = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })

    const getIcon = computed(() => {
      const iconMap = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information'
      }
      return iconMap[props.type]
    })

    const getIconColor = computed(() => {
      const colorMap = {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'info'
      }
      return colorMap[props.type]
    })

    const getButtonColor = computed(() => {
      const colorMap = {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'primary'
      }
      return colorMap[props.type]
    })

    const close = () => {
      dialog.value = false
    }

    return {
      dialog,
      getIcon,
      getIconColor,
      getButtonColor,
      close
    }
  }
})
</script>

<style scoped>
.notification-dialog {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.notification-dialog :deep(.v-card-text) {
  color: #fff !important;
}

.notification-dialog :deep(.v-card-actions) {
  color: #fff !important;
}

.notification-icon {
  flex-shrink: 0;
}

.notification-content {
  min-width: 0;
}

.notification-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.notification-message {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
}

.notification-close-btn {
  color: rgba(255, 255, 255, 0.6) !important;
  flex-shrink: 0;
}

.notification-close-btn:hover {
  color: rgba(255, 255, 255, 0.8) !important;
}

.notification-btn {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  min-width: 80px;
}
</style> 